/*
 * Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { Merchant } from "../../../models";
import { AuthService, MerchantService } from "../../../services";
import { MERCHANT_CONSTANTS } from "../../../utils/data.rest.constants";
import * as moment from "moment";

@Component({
  selector: "app-general-info",
  templateUrl: "./general-info.component.html"
})
export class GeneralInfoComponent implements OnInit {
  MCC_CODE: any = MERCHANT_CONSTANTS.SIC_MCC_CODE;
  @Input("merchant") merchant!: Merchant;
  merchantConversionDate = "";

  constructor(public merchantService: MerchantService, public authService: AuthService) {}

  isInstaMedOrGlobalPayments(): boolean {
    return this.merchantService.isInstaMed(this.merchant) || this.merchantService.isGlobalPayments(this.merchant);
  }

  ngOnInit(): void {
    if (
      this.merchant?.merchantMigrationDetails?.toBeMigrated &&
      this.merchant.merchantMigrationDetails?.effectiveDate !== null
    ) {
      this.merchantConversionDate = moment(this.merchant.merchantMigrationDetails?.effectiveDate).format("MM/DD/YYYY");
    } else {
      this.merchantConversionDate = "";
    }
  }
}
